import React from 'react';
import { Settings, Heart } from 'lucide-react';
import { useQuestionnaire } from './QuestionnaireContext';
export const PersonalizationButton: React.FC = () => {
  const {
    openQuestionnaire,
    state
  } = useQuestionnaire();
  return <button onClick={openQuestionnaire} className="flex items-center gap-2 px-3 py-1.5 text-sm rounded-full bg-pink-50 dark:bg-pink-900/20 text-pink-600 dark:text-pink-400 border border-pink-100 dark:border-pink-800/30 hover:bg-pink-100 dark:hover:bg-pink-800/30 transition-colors" title="Personalize your experience" data-id="element-15160">
      {state.isComplete ? <>
          <Settings size={14} data-id="element-15161" />
          <span data-id="element-15162">Personalize</span>
        </> : <>
          <Heart size={14} data-id="element-15163" />
          <span data-id="element-15164">Get to Know You</span>
        </>}
    </button>;
};